import React, { FC } from "react";

type Props = Record<string, never>;
const AnimeShoppingTerms: FC<Props> = () => {
  return (
    <>
      <section>
        <h1>
          <span style={{ display: "inline-block" }}>アニメショッピング</span>
          <span style={{ display: "inline-block" }}>に関する特約</span>
        </h1>
      </section>
      <section>
        <p>
          本特約は、当社が運営する「アニメファンド」を通じて提供されるサービス「アニメショッピング（通称：通販）」の利用条件を定めるものです（以下「本特約」といいます）。
          アニメショッピングの利用にあたっては、アニメファンド利用規約（以下「原規約」といいます）に加えて、本特約のすべてに同意いただく必要があります。
          また、アニメショッピングの利用により、会員は、本特約及び会員が利用するサービスごとに定められたガイドラインや注意事項に同意したものとみなされます。
        </p>
      </section>
      <section>
        <h4>第１条（定義）</h4>
        <p>本特約において用いる用語の定義は次の通りとします。</p>
        <ul>
            <li>
              （1）「アニメショッピング」
              <br />
              本サービスのうち、商品の通信販売を提供するサービス
              <br />
              クラウドファンディングやふるさと納税のサービスとは異なり、プロジェクトとして成立したリターンを提供するものではない
              <br />
              あくまでも、該当するアニメ関連グッズを通信販売として提供するものとする
            </li>
        </ul>
      </section>
      <section>
        <h4>第2条（適用）</h4>
        <p>本特約は、原規約に優先して適用されるものとします。また、本特約に定めのない事項は、原規約の定めに従うものとします。</p>
      </section>
    </>
  );
}
export default AnimeShoppingTerms;
